/**
 * BodyText - Simple text paragraph wrapper
 *
 * Used in deployment modals for consistent text styling.
 */

import React from "react";
import { twClassNames } from "../../../../helpers/twClassNames";

interface BodyTextProps {
    children: React.ReactNode;
    className?: string;
}

export function BodyText({ children, className }: BodyTextProps) {
    return <p className={twClassNames("mb-4 text-sm text-gray-700", className)}>{children}</p>;
}
